// extracted by mini-css-extract-plugin
module.exports = {"container":"RotateDevice_container__2O4ub","text":"RotateDevice_text__yFr4k"};